import { RootState } from '@/store/types'
import { Module } from 'vuex'
import { actions } from './actions'
import { getters } from './getters'
import { mutations } from './mutations'
import { FormState } from './types'


export const state: FormState = {
  messages: {},
  widgets: [],
  icons: {},
  queryFields: [],
  defaultWidgetId: '',
  activeWidgetId: ''
}

const namespaced: boolean = true

export const form: Module<FormState, RootState> = {
  namespaced,
  state,
  getters,
  mutations,
  actions,
}
